import React from "react";
import moment from "moment";
import { Form } from "antd";
import ProfileInfoSection from "../../common/FormSections/profileInfo";
import ProfilePosition from "../../common/FormSections/profilePosition";

class ProfileInfo extends React.Component {
  render() {
    const { form, isEditable, userId } = this.props;

    return (
      <div className="card-info">
        <Form layout="inline">
          <div className="offer-card__section" style={{ paddingTop: 0 }}>
            <ProfilePosition form={form} />
            <ProfileInfoSection
              form={form}
              disabled={!isEditable}
              userId={userId}
            />
          </div>
        </Form>
      </div>
    );
  }
}

class ProfileInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };
    this.flagInitEditing = false;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.initEditing();
  }
  componentDidMount() {
    this.initEditing();
  }
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  //
  initEditing = () => {
    let { isEditable } = this.props;
    let dataProps = this.props.data;
    if (!this.flagInitEditing && isEditable) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item]
          };
        });
      }
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        if (this.formRef) {
          this.formRef.validateFields((errors, values) => {
            this.changeValues(values);
          });
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };
  handleFieldsChange = values => {
    this.setState(
      {
        data: {
          ...this.state.data,
          ...values
        }
      },
      () => {
        this.changeValues(values);
      }
    );
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      // this.props.updateProgress(values);
    }
  };

  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    return (
      <FormProfileInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
      />
    );
  }
}

const FormProfileInfo = Form.create({
  name: "formProfileInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};

    props.data &&
      Object.keys(props.data).forEach(name => {
        let all = true;
        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(ProfileInfo);

export default ProfileInfoData;
